<app-icon-button (click)="minusMinute()" actionId="Vähennä kirjanpidon kellonaikaa minuutilla" additionalClass="secondarybutton" styles="border: 0px; height: 24px; width: 40px; padding: 0 5px; min-width: unset; line-height: 24px; font-size: 16px; border-color: white;">
  <i class="fa fa-minus" style="font-size: 16px; vertical-align: unset"></i>
</app-icon-button>
<!-- style="margin-left: 10px;" -->
<span class="clock-container" [class.clock-running]="isClockRunningObservable | async">
  <app-icon-button (click)="togglePause()" actionId="Laita kirjanpidon kello päälle/tauolle" styles="border: 0px; height: 24px; width: 30px; padding: 0; min-width: unset; line-height: 24px; font-size: 18px;">
    @if (isClockRunningObservable | async) {
      <i class="fa fa-clock-o" style="font-size: 16px; vertical-align: unset; color: black"></i>
    }
    @if (isClockRunningObservable | async) {
      <i class="fa fa-pause" style="font-size: 15px; vertical-align: unset; color: black"></i>
    }
    @if (!(isClockRunningObservable | async)) {
      <i class="fa fa-play" style="font-size: 15px; vertical-align: unset; color: black"></i>
    }
  </app-icon-button>
</span>
<span class="green-text" #timeElement style="line-height: 25px; font-size: 18px; margin-left: 0; margin-right: 10px"></span>
<app-icon-button (click)="plusMinute()" actionId="Lisää kirjanpidon kellonaikaa minuutilla" additionalClass="secondarybutton" styles="border: 0px; height: 24px; width: 40px; padding: 0 5px; min-width: unset; line-height: 24px; font-size: 16px; border-color: white;">
  <i class="fa fa-plus" style="font-size: 16px; vertical-align: unset"></i>
</app-icon-button>
<!-- Aika tietokannassa: {{currentTimeInDatabaseObservable | async}}
Aika kulunut: {{currentElapsedTimeObservable | async}} -->
